export default __webpack_public_path__ + "static/media/Mark of Suspicion.bf0150af.jpg";